import React from 'react';
import { useSelector } from 'react-redux';
import { BarsIcon } from 'assets/icons';
import FirstHelpShadow from 'components/Help/FirstHelpShadow';
import LogoutButton from 'components/LogoutButton';
import IconMenu from 'components/Page/Header/TopHeader/IconMenu/IconMenu';
import LinkTabs from 'components/Page/Header/TopHeader/Links/LinkTabs';
import RenaultGroupLogo from 'components/Page/Header/TopHeader/Logos/RenaultGroupLogo';
import RpartStoreLogo from 'components/Page/Header/TopHeader/Logos/RpartStoreLogo';
import { AntHeader, PageHeaderDiv } from 'components/Page/Header/TopHeader/TopHeader.styled';
import UserInfo from 'components/Page/Header/TopHeader/UserInfo/UserInfo';
import { getTokenUser, getUserDisplayMode, getUserRights, UserRole } from 'domains/user';
import { theme } from 'styles';
import { Flex, Icon, MarginBox } from 'UI';
import { getData, useLarge, useMedium } from 'utils';
import Search from './Search';

export const HEADER_HEIGHT = 64;

export interface HeaderProps {
  switchMenu: () => void;
  'data-cy'?: string;
}

const TopHeader = ({ switchMenu, 'data-cy': dataCy }: HeaderProps) => {
  const userDisplayMode = useSelector(getUserDisplayMode);
  const iconColor = theme.color.white;
  const iconHoverFill = theme.color.white85;
  const user = useSelector(getTokenUser);

  const medium = useMedium();
  const large = useLarge();
  const userRoles = getData(useSelector(getUserRights)) ?? [];
  const isCdeIt = !!userRoles.find((x) => x === UserRole.R1_ORDER_AND_CLAIM);
  const shouldShowLinks = large;
  const shouldShowSearchArea = medium;
  const shouldShowSearch = medium && !isCdeIt;

  return (
    <AntHeader height={HEADER_HEIGHT} data-cy={dataCy}>
      <FirstHelpShadow header />
      <PageHeaderDiv height={HEADER_HEIGHT} displayMode={userDisplayMode}>
        <MarginBox mr={large ? 24 : 0}>
          <Flex align={'center'} gap={10} padding={'0 30px 0 30px'} size={0} minHeight={HEADER_HEIGHT}>
            <Icon
              IconComponent={BarsIcon}
              onClick={switchMenu}
              size={24}
              display={'block'}
              data-cy={'hamburger-menu'}
            />
            <RenaultGroupLogo />
            <RpartStoreLogo />
          </Flex>
        </MarginBox>
        {shouldShowLinks && (
          <div>
            <LinkTabs />
          </div>
        )}
        {!shouldShowSearch && <Flex />}
        {shouldShowSearchArea && (
          <Flex justify={'center'}>
            <Flex minWidth={100} maxWidth={large ? 250 : 200} padding={'0 10px 0 0'}>
              {shouldShowSearch && <Search />}
            </Flex>
          </Flex>
        )}
        <Flex size={0} justify={'flex-end'}>
          <IconMenu iconColor={iconColor} iconHoverFill={iconHoverFill} showExtendedIcons={medium} />
          <MarginBox my={'auto'} mx={16}>
            <UserInfo />
          </MarginBox>
          <MarginBox my={'auto'} mr={8}>
            <LogoutButton small iconColor={iconColor} iconHoverFill={iconHoverFill} data-cy={'logout-button'} />
          </MarginBox>
          <div hidden className={'userIdentification'} data-cy={'user-identification-hidden'}>
            {user?.id} - {user?.firstName} {user?.lastName}
          </div>
        </Flex>
      </PageHeaderDiv>
    </AntHeader>
  );
};

export default TopHeader;
